import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useZitoneoUI } from '../../../contexts/ZitoneoUIContext';
import { VisibleContentScope } from '../../../types/zitoneoServicesTypes';
import ModeSelector from './ModeSelector';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';
import { useZitoneoHotelRooms } from '../../../contexts/ZitoneoContentContext';

const ContentModeSelector = () => {
    const translate = useTranslate();
    const { visibleContentScope, handleVisibleContentScope } = useZitoneoUI();
    const { rooms } = useZitoneoHotelRooms();

    return (
        <ModeSelector
            selectedValue={visibleContentScope}
            onChange={scope =>
                handleVisibleContentScope(scope, rooms[0]?.Id || null)
            }
            options={[
                {
                    value: VisibleContentScope.HOTEL,
                    iconName: commonIcons.HOTEL,
                    label: translate('hotel'),
                },
                {
                    value: VisibleContentScope.ROOM,
                    iconName: commonIcons.ROOM,
                    label: translate('rooms'),
                },
            ]}
        />
    );
};

export default ContentModeSelector;
